import React from 'react';
import { Star, Heart, Shield, Clock, Sparkles, Award, Users } from 'lucide-react';
import { medicalImages } from '../data/mock';

// Simple and Beautiful Statistics Section Component
export const StatsSection = () => {
  const stats = [
    {
      number: "10+",
      label: "Années d'expérience",
      icon: Award,
      color: "text-blue-600",
      bgColor: "bg-blue-100"
    },
    {
      number: "OIIQ",
      label: "Membre certifiée",
      icon: Shield,
      color: "text-green-600",
      bgColor: "bg-green-100"
    },
    {
      number: "2",
      label: "Spécialités principales",
      icon: Heart,
      color: "text-red-500",
      bgColor: "bg-red-100"
    },
    {
      number: "7j/7",
      label: "Disponibilité",
      icon: Clock,
      color: "text-purple-600",
      bgColor: "bg-purple-100"
    }
  ];

  return (
    <div className="section-spacing bg-pattern-dots">
      <div className="container">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="service-card accent-purple text-center hover-lift">
              <div className={`w-20 h-20 ${stat.bgColor} rounded-full flex items-center justify-center mx-auto mb-4`}>
                <stat.icon size={32} className={stat.color} />
              </div>
              <h3 className="heading-2 gradient-text mb-2">{stat.number}</h3>
              <p className="body-medium text-gray-700">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// Medical Services Features Section Component
export const MedicalFeaturesSection = () => {
  const features = [
    {
      title: "Soins de plaies professionnels",
      description: "Traitement expert des plaies avec techniques modernes et pansements spécialisés",
      image: medicalImages.woundCare.treatment,
      accent: "accent-blue"
    },
    {
      title: "Soins de pieds spécialisés",
      description: "Expertise en podologie pour traiter ongles incarnés, cors et problèmes diabétiques",
      image: medicalImages.footCare.xray,
      accent: "accent-green"
    },
    {
      title: "Matériel médical professionnel",
      description: "Équipement stérilisé et fournitures médicales de qualité hospitalière",
      image: medicalImages.medical.injection,
      accent: "accent-cream"
    }
  ];

  return (
    <div className="section-spacing-large bg-white">
      <div className="container">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-6">
            <Heart size={24} className="text-red-500" />
            <span className="body-small font-semibold text-gray-800 uppercase tracking-wide">
              Nos expertises
            </span>
          </div>
          <h2 className="heading-1 mb-6">Des soins spécialisés à domicile</h2>
          <p className="body-large text-gray-800 max-w-3xl mx-auto">
            Bénéficiez de soins infirmiers professionnels dans le confort de votre foyer, 
            avec l'expertise et l'équipement d'une clinique.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-12">
          {features.map((feature, index) => (
            <div key={index} className={`service-card ${feature.accent} hover-lift text-center`}>
              <div className="mb-8">
                <img 
                  src={feature.image} 
                  alt={feature.title}
                  className="w-full h-64 object-cover rounded-xl service-image"
                />
              </div>
              <h3 className="heading-2 mb-4">{feature.title}</h3>
              <p className="body-medium text-gray-700 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// Medical Gallery Section Component
// Section supprimée : Notre expertise en images

// Simple Call-to-Action Section Component
export const CTASection = ({ title, description, primaryButton, secondaryButton }) => {
  return (
    <div className="section-spacing parallax-section relative" 
         style={{
           backgroundImage: `linear-gradient(135deg, rgba(252, 202, 199, 0.9), rgba(248, 216, 251, 0.9))`,
         }}>
      <div className="container relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="hero-announcement bg-white/30 text-gray-800 border-white/40 mb-8">
            <Heart size={20} className="text-red-500" />
            <span>Nouveau service à Longueuil</span>
          </div>
          
          <h2 className="heading-hero text-gray-800 mb-8">
            {title || "Prêt à recevoir des soins professionnels ?"}
          </h2>
          
          <p className="body-large text-gray-700 mb-12 max-w-3xl mx-auto leading-relaxed">
            {description || "Contactez Salwa dès aujourd'hui pour planifier une consultation personnalisée et découvrir comment nos soins spécialisés peuvent améliorer votre bien-être."}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            {primaryButton || (
              <button className="btn-primary">
                <span className="button-text">Prendre rendez-vous</span>
              </button>
            )}
            {secondaryButton || (
              <button className="btn-secondary">
                <span className="button-text">En savoir plus</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default {
  StatsSection,
  MedicalFeaturesSection,
  CTASection
};